/*
 * @Description: 腾讯云COS文件上传工具
 */
import COS from 'cos-js-sdk-v5';

// COS配置
const COS_CONFIG = {
  Bucket : 'crm-1304488676',
  Region : 'ap-beijing',
  secret_key : 'LSXw75qKX9VbQxCyThg2B5rM1QYP1OVN',
  secret_id : 'AKIDbykd9y7DZe38zeqBXhhoLelcR4NRMRFa',
}

/**
 * 上传文件到COS（前端直传，需要在腾讯云COS控制台配置CORS规则）
 * @param {File} file - 要上传的文件
 * @param {string} folder - 存储路径前缀（可选）
 * @returns {Promise} 返回上传结果，包含文件URL、Key等信息
 */
export const uploadToCOS = async (file, folder = 'town_introduction/questionnaire') => {
  // 初始化COS实例（使用永久密钥）
  const cos = new COS({
    SecretId: COS_CONFIG.secret_id,
    SecretKey: COS_CONFIG.secret_key,
    UseAccelerate: false,
    Timeout: 60000,
  });

  // 生成文件Key（路径）
  const lastDotIndex = file.name.lastIndexOf('.');
  const fileNameWithoutExt = lastDotIndex > 0 
    ? file.name.substring(0, lastDotIndex) 
    : file.name;
  const fileExt = lastDotIndex > 0 
    ? file.name.substring(lastDotIndex) 
    : '';
  
  // 用毫秒的时间戳作为随机字符串
  const randomStr = Date.now();
  
  // 文件名格式：随机字符串_原文件名.扩展名
  const fileName = `${randomStr}_${fileNameWithoutExt}${fileExt}`;
  const Key = `${folder}/${fileName}`;

  return new Promise((resolve, reject) => {
    cos.putObject(
      {
        Bucket: COS_CONFIG.Bucket,
        Region: COS_CONFIG.Region,
        Key: Key,
        Body: file,
        onProgress: (progressData) => {
          const percent = Math.round(progressData.percent * 100);
          console.log(`上传进度: ${percent}%`);
        },
      },
      (err, data) => {
        if (err) {
          console.error('COS上传错误:', err);
          if (err.message && err.message.includes('CORS')) {
            const corsError = new Error('CORS 跨域错误：请在腾讯云 COS 控制台配置存储桶的 CORS 规则。允许来源：*，允许方法：PUT, POST, GET, HEAD，允许头部：*');
            corsError.name = 'CORSError';
            reject(corsError);
          } else {
            reject(err);
          }
        } else {
          const fileUrl = `https://${COS_CONFIG.Bucket}.cos.${COS_CONFIG.Region}.myqcloud.com/${Key}`;
          
          resolve({
            success: true,
            url: fileUrl,
            key: Key,
            etag: data.ETag,
            size: file.size,
            name: file.name,
            fileName: file.name,
            location: data.Location,
            data: {
              ...data,
              url: fileUrl,
              key: Key,
              fileName: file.name,
              fileSize: file.size,
            },
          });
        }
      }
    );
  });
};

/**
 * 删除COS中的文件
 * @param {string} key - 文件在COS中的Key（路径）
 * @returns {Promise} 返回删除结果
 */
export const deleteFromCOS = async (key) => {
  // 初始化COS实例（使用永久密钥）
  const cos = new COS({
    SecretId: COS_CONFIG.secret_id,
    SecretKey: COS_CONFIG.secret_key,
    UseAccelerate: false,
    Timeout: 30000,
  });

  return new Promise((resolve, reject) => {
    cos.deleteObject(
      {
        Bucket: COS_CONFIG.Bucket,
        Region: COS_CONFIG.Region,
        Key: key,
      },
      (err, data) => {
        if (err) {
          console.error('COS删除错误:', err);
          reject(err);
        } else {
          resolve({
            success: true,
            data: data,
          });
        }
      }
    );
  });
};

/**
 * 批量上传文件到COS
 * @param {Array<File>} files - 要上传的文件数组
 * @param {string} folder - 存储路径前缀（可选）
 * @param {Function} onProgress - 进度回调函数 (current, total, file) => {}
 * @returns {Promise<Array>} 返回所有文件的上传结果
 */
export const uploadMultipleToCOS = async (files, folder = 'town_introduction/questionnaire', onProgress) => {
  const results = [];
  const total = files.length;
  
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    try {
      if (onProgress) {
        onProgress(i + 1, total, file);
      }
      
      const result = await uploadToCOS(file, folder);
      results.push({
        ...result,
        fileName: file.name,
      });
    } catch (error) {
      results.push({
        success: false,
        fileName: file.name,
        error: error.message || '上传失败',
      });
    }
  }
  
  return results;
};

